const globalCallbackStack = new Map();
const HtmlElements = document.querySelector('script[src*="HtmlElements.js"]'),
    scriptSrc = HtmlElements ? HtmlElements.src : document.location.origin + '/_/scripts/rgElements/HtmlElements.js',
    url = new URL(scriptSrc),
    paths = url.pathname.split('/');
paths.pop();
paths.includes('src') && paths.push('Elements');

export class rgElement extends HTMLElement {
    rootpath = '';
    form = null;

    constructor() {
        super();
    }

    setUpElement() {
        this.rootpath = paths.join('/') + (this.constructor.name ? '/' + this.constructor.name : '');
        this.form = this.closest('form');
        this.setAttribute('data-rgelement', true);
    }

    setupComplete() {
        document.dispatchEvent(new CustomEvent('rgelement:initialized', {detail: {element: this}}));
    }

    getStyles(originalSelector, newSelector) {
        let cssRules = '';
        [...document.styleSheets].map(styleSheet => {
            try {
                let sheetRules = styleSheet.cssRules || styleSheet.rules;
                let rxOriginalSelector = new RegExp(originalSelector, 'g');
                [...sheetRules].map(rule => {
                    let cssMediaRules = '';
                    if(rule.selectorText && rule.selectorText.match(originalSelector)) {
                        rule.selectorText = rule.selectorText.replace(rxOriginalSelector, newSelector);
                        cssRules = cssRules + rule.cssText;
                    } else if(rule.media && (rule.cssRules)) {
                        [...rule.cssRules].map(rule => {
                            if(rule.selectorText && rule.selectorText.match(originalSelector)) {
                                rule.selectorText = rule.selectorText.replace(rxOriginalSelector, newSelector);
                                cssMediaRules = cssMediaRules + rule.cssText;
                            }
                        })
                        if(cssMediaRules !== '') {
                            cssRules = cssRules + ' @media ' + rule.conditionText + '{' + cssMediaRules + '} '
                        }
                    }
                });
            } catch(e) {
            }
        });
        return cssRules;
    }

    copyStyles(selector) {
        let cssRules = '';
        [...document.styleSheets].map(styleSheet => {
            try {
                let sheetRules = styleSheet.cssRules || styleSheet.rules;
                [...sheetRules].map(rule => {
                    let cssMediaRules = '';
                    if(rule.selectorText && rule.selectorText.match(selector)) {
                        cssRules = cssRules + rule.cssText;
                    } else if(rule.media && (rule.cssRules)) {
                        [...rule.cssRules].map(rule => {
                            if(rule.selectorText && rule.selectorText.match(selector)) {
                                cssMediaRules = cssMediaRules + rule.cssText;
                            }
                        })
                        if(cssMediaRules !== '') {
                            cssRules = cssRules + ' @media ' + rule.conditionText + '{' + cssMediaRules + '} '
                        }
                    }
                });
            } catch(e) {
            }
        });
        return cssRules;
    }

    parseAttribute(attribute) {
        if(attribute !== undefined) {
            if(attribute === 'false' || attribute === 'true') {
                return JSON.parse(attribute);
            }
            if(attribute.match(/^\d+$/)) {
                return Number(attribute);
            }
        }
        return attribute;
    }

    loadFile(path, callback, type, insertPoint = null) {
        if(!['css', 'js'].includes(type)) {
            console.error('unsupportet type: "' + type + '"');
            return;
        }
        if(insertPoint === null) {
            insertPoint = document.querySelector('head');
        }
        let localCallbackStack = globalCallbackStack.get(insertPoint);
        if(!localCallbackStack) {
            localCallbackStack = new Map();
            globalCallbackStack.set(insertPoint, localCallbackStack);
        }
        let fileCallbackStack = localCallbackStack.get(path);
        if(!fileCallbackStack) {
            fileCallbackStack = {
                loading: true,
                callbacks: []
            };
            localCallbackStack.set(path, fileCallbackStack);
            globalCallbackStack.set(insertPoint, localCallbackStack);
        }
        if(!fileCallbackStack.loading && typeof callback === 'function') {
            callback();
        } else {
            fileCallbackStack.callbacks.push(callback);
            localCallbackStack.set(path, fileCallbackStack);
            globalCallbackStack.set(insertPoint, localCallbackStack);
            let selector;
            switch(type) {
                case 'css':
                    selector = 'link[href="' + path + '"]';
                    break;
                case 'js':
                    selector = 'script[src="' + path + '"]'
                    break;
            }
            if(!insertPoint.querySelector(selector)) {
                let element;
                switch(type) {
                    case 'css':
                        element = document.createElement('link');
                        element.setAttribute('rel', 'stylesheet');
                        element.setAttribute('href', path);
                        break;
                    case 'js':
                        element = document.createElement('script');
                        element.setAttribute('src', path);
                        break;
                }
                element.onload = function() {
                    // let stack = globalCallbackStack.get(path);
                    fileCallbackStack.loading = false;
                    localCallbackStack.set(path, fileCallbackStack);
                    globalCallbackStack.set(insertPoint, localCallbackStack);
                    fileCallbackStack.callbacks.forEach(cb => {
                            if(typeof cb === 'function') {
                                cb();
                            }
                        }
                    )
                }
                insertPoint?.append(element);
            }
        }
    }

    loadCss(path, callback) {
        this.loadFile(path, callback, 'css');
    }

    loadScript(path, callback) {
        this.loadFile(path, callback, 'js');
    }

    loadFiles(files, callback) {
        let promises = [];
        for(const file of files) {
            promises.push(new Promise((res, rej) => {
                this.loadFile(
                    file.path,
                    () => {
                        if('callback' in file) {
                            file.callback();
                        }
                        if('followup' in file) {
                            this.loadFiles(file.followup, () => {
                                res();
                            })
                        } else {
                            res();
                        }
                    },
                    file.type,
                    file.insertPoint ?? null);
            }));
        }
        Promise.all(promises).then(() => {
            callback();
        })
    }

    extendApi(path) {
        import(/* webpackIgnore: true */this.rootpath + path).then(function(defaultExport) {
            this.dispatchEvent(new CustomEvent(this.tagName.toLowerCase() + ':apiloaded', {
                detail: {
                    el: this,
                    defaultExport: defaultExport
                }
            }));
        }.bind(this));
    }
}